import { attachPlanList, delAttachPlan, attachPlanStatus } from './../request';
import { COLUMNSPLANLIST } from './utils';
import planModal from './palnModel.vue';
export default {
  components: {
    planModal
  },
  props: {
    id: {
      type: Number,
      default: -1,
      required: true
    }
  },
  data() {
    return {
      COLUMNSPLANLIST,
      tableData: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      planShow: false
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      let obj = {
        attachId: this.id,
        pageSize: this.pagination.pageSize,
        page: this.pagination.current
      };
      const {
        totalNum,
        items
      } = await attachPlanList(obj);
      this.pagination.total = totalNum;
      this.tableData = items;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleAdd() {
      this.planShow = true;
      this.$nextTick(() => {
        this.$refs.planRef.init(this.id, false, 'add');
      });
    },
    handleEdit(val) {
      this.planShow = true;
      this.$nextTick(() => {
        this.$refs.planRef.init(this.id, val, 'edit');
      });
    },
    handleDelete(val) {
      if (val.status == 1) {
        return this.$message.error(this.$t('请禁用方案后删除'));
      }
      let _this = this;
      this.$alert(this.$t('是否确认删除该产品方案') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delAttachPlan({
          insuranceAttachPlanId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('操作成功') + '!');
          _this.getDataFun();
        });
      });
    },
    handleCopy(val) {
      this.planShow = true;
      this.$nextTick(() => {
        this.$refs.planRef.init(this.id, val, 'copy');
      });
    },
    async checkedFun(val) {
      await attachPlanStatus({
        insuranceAttachPlanId: val.id,
        status: val.status == 1 ? 0 : 1
      });
      this.$message.success(this.$t('修改成功') + '!');
      this.getDataFun();
    },
    saveFun() {
      if (this.pagination.total == 0 || this.tableData.findIndex(i => i.status == 1) < 0) {
        const that = this;
        this.$confirm({
          title: this.$t('当前产品未配置方案信息，将无法与主险产品关联，是否继续保存数据'),
          onOk() {
            that.$router.go(-1);
          }
        });
      } else {
        this.$router.go(-1);
      }
    }
  }
};